<form action="" [formGroup]="cesionFormGroup" (ngSubmit)="onSubmit()" #localFormRef="ngForm">
	<div class="mt-4">
		<div class="text-center">
			<div class="row">
				<div class="col-12">
					<div class="row">
						<div class="col-3">Folio: {{ receivedDte.folio }}</div>
						<div class="col-3">Rut: {{ receivedDte.rutReceptorDv }}</div>
						<div class="col-3">Nombre: {{ receivedDte.razonSocial }}</div>
						<div class="col-3">Fecha: {{ receivedDte.fecha | date : "dd/MM/yyyy" }}</div>
					</div>
					<div class="row mt-2">
						<div class="offset-sm-4 col-4">
							<b>Fecha Vencimiento: {{ fechaVencimientoEfectiva | date : "dd/MM/yyyy" }}</b>
						</div>
					</div>
					<div class="row mt-2">
						<div class="offset-sm-4 col-4">
							<b>Monto: {{ receivedDte.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</b>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-body">
		<!-- Identificacion del Cedente Emisor -->
		<h3>Identificación del Cedente</h3>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Rut</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="rutEmisor" [attr.disabled]="true" />
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Razón Social</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="razonSocialEmisor" [attr.disabled]="true" />
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Dirección</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="direccionEmisor" [attr.disabled]="true" />
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="" class="col-3 label-control">Persona Autorizada</label>
			<div class="col-9">
				<ng-select [items]="personasAutorizadasSource" bindLabel="nombre" [clearable]="false" formControlName="personaAutorizada" (change)="changePersonaAutorizada($event)"> </ng-select>
				<div *ngIf="cesionFormGroup.controls.personaAutorizada && (cesionFormGroup.touched || cesionFormGroup.dirty) && cesionFormGroup.controls.personaAutorizada.invalid" class="text-danger">
					<div *ngIf="cesionFormGroup.controls.personaAutorizada.errors?.required">Campo Requerido</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Rut Autorizado</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="rutAutorizado" [attr.disabled]="true" />
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Nombre Autorizado</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="nombreAutorizado" [attr.disabled]="true" />
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Correo Electronico</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="emailAutorizado" [attr.disabled]="true" />
			</div>
		</div>

		<!-- Identificacion del Cesionario -->
		<h3>Identificación del Cesionario</h3>

		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Rut Cesionario</label>
			<div class="col-9">
				<div class="input-group">
					<input
						type="search"
						class="form-control"
						formControlName="rutCesionario"
						maxlength="12"
						appFormatRut
						(keyup.enter)="buscaCesionario($event.target.value)"
						(blur)="buscaCesionario($event.target.value)"
						[ngClass]="{
							spinner: loadingCesionario
						}"
						ngbTooltip="Ingrese el rut del cesionario para su busqueda o utilice la lupa para mostrar los cesionarios disponibles" />
					<div class="input-group-append">
						<button class="btn btn-outline-secondary" type="button" (click)="openCesionarioListModal(cesionarioListModal)">
							<i class="fa fa-search"></i>
						</button>
					</div>
				</div>

				<div *ngIf="cesionFormGroup.controls.rutCesionario && (cesionFormGroup.touched || cesionFormGroup.dirty) && cesionFormGroup.controls.rutCesionario.invalid" class="text-danger">
					<div *ngIf="cesionFormGroup.controls.rutCesionario.errors?.required">Campo Requerido</div>
					<div *ngIf="cesionFormGroup.get('rutCesionario').hasError('VerificacionRutValidator')">Rut no válido</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Nombre Cesionario</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="nombreCesionario" [attr.disabled]="true" />
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Dirección Cesionario</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="direccionCesionario" [attr.disabled]="true" />
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Correo Electrónico Cesionario</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="emailCesionario" [attr.disabled]="true" />
			</div>
		</div>

		<!-- Informacion de la cesion -->
		<h3>Información de la Cesión</h3>

		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Correo Electrónico Deudor</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="emailDeudor" />
				<div *ngIf="cesionFormGroup.controls.emailDeudor && (cesionFormGroup.touched || cesionFormGroup.dirty) && cesionFormGroup.controls.emailDeudor.invalid" class="text-danger">
					<div *ngIf="cesionFormGroup.controls.emailDeudor.errors?.required">Campo Requerido</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Declaración Jurada</label>
			<div class="col-9">
				<textarea class="form-control" formControlName="declaracionJurada" cols="5" rows="5" style="resize: none" [attr.disabled]="true"></textarea>
				<div *ngIf="cesionFormGroup.controls.declaracionJurada && (cesionFormGroup.touched || cesionFormGroup.dirty) && cesionFormGroup.controls.declaracionJurada.invalid" class="text-danger">
					<div *ngIf="cesionFormGroup.controls.declaracionJurada.errors?.required">Campo Requerido</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-auto">
			<label for="rutCedente" class="col-3 label-control">Otras condiciones</label>
			<div class="col-9">
				<input type="text" class="form-control" formControlName="otrasCondiciones" />
				<div *ngIf="cesionFormGroup.controls.otrasCondiciones && (cesionFormGroup.touched || cesionFormGroup.dirty) && cesionFormGroup.controls.otrasCondiciones.invalid" class="text-danger">
					<div *ngIf="cesionFormGroup.controls.otrasCondiciones.errors?.required">Campo Requerido</div>
				</div>
			</div>
		</div>
		<!-- Contacto -->
	</div>
	<div class="modal-footer">
		<div class="form-group position-relative has-icon-left mb-0">
			<button type="submit" class="btn btn-success">
				<i class="la la-paper-plane-o d-lg-none"></i>
				<span class="d-none d-lg-block">Generar</span>
			</button>
			<button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
				<span class="d-none d-lg-block">Cerrar</span>
			</button>
		</div>
	</div>
</form>

<ng-template #cesionarioListModal let-d="dismiss" let-c="close">
	<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"> </ngx-loading>
	<ng-template #customLoadingTemplate></ng-template>
	<div class="modal-lg">
		<div class="modal-body">
			<section class="row">
				<div class="col-12">
					<div class="card card-custom">
						<div class="card-header">
							<h4 class="card-title">Busqueda de Cesionario</h4>
						</div>
						<div class="card-head">
							<app-search-bar [config]="configLocal.barraBusqueda" [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [filtroEstadoPlan]="true" [insideModal]="true" (busqueda)="searchElementsByFilter($event)"></app-search-bar>
						</div>
						<div class="card-content">
							<div class="card-body">
								<ngx-datatable
									class="material rows contacts-table"
									[rows]="CesionariofullList"
									[columnMode]="'flex'"
									[headerHeight]="50"
									[footerHeight]="50"
									[rowHeight]="70"
									fxFlex="auto"
									[externalPaging]="true"
									[count]="page.totalElements"
									[offset]="page.pageNumber"
									[limit]="page.pageSize"
									(page)="setPage($event)"
									[selected]="selected"
									[selectionType]="SelectionType.single"
									(activate)="onActivate($event)"
									[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos' | translate, selectedMessage: false }">
									<ngx-datatable-column name="Rut" [flexGrow]="3" [sortable]="false" [resizeable]="false">
										<ng-template let-column="column" ngx-datatable-header-template>
											<span class="text-table-alignment">Rut Cesionario</span>
										</ng-template>
										<ng-template ngx-datatable-cell-template let-row="row"
											><span class="text-table-alignment">{{ row.rutFormateado }}</span></ng-template
										>
									</ngx-datatable-column>
									<ngx-datatable-column name="razonSocial" [flexGrow]="4" [sortable]="false" [resizeable]="false">
										<ng-template let-column="column" ngx-datatable-header-template>
											<span class="text-table-alignment">Razón Social</span>
										</ng-template>
										<ng-template ngx-datatable-cell-template let-row="row"
											><span class="text-table-alignment">{{ row.razonSocial }}</span></ng-template
										>
									</ngx-datatable-column>
								</ngx-datatable>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</ng-template>
